<template>
  <div class="map">
    <div class="map-container px-4">
      <div class="inner-wrapper">
        <l-map
          style=""
          :zoom="zoom"
          :center="center"
          @update:zoom="zoomUpdated"
          @update:center="centerUpdated"
          @update:bounds="boundsUpdated"
        >
          <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
          <l-marker
            ref="alizoka"
            v-for="(loc, index) in location_stores"
            :key="index"
            :lat-lng="[loc.lat, loc.long]"
          >
            <l-popup ref="popup">{{ loc.name }}</l-popup>
          </l-marker>
        </l-map>
      </div>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import Service from "../../../utils/admin-service";
import { computed, onMounted, ref } from "@vue/composition-api";

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 7,
      center: [37, 52],
      bounds: null,
      markerLatLng: [47.31322, -1.319482],
    };
  },

  setup() {
    onMounted(() => {
      get_locations();
    });
    const authService = computed(() => {
      return Service(true);
    });
    const get_locations = () => {
      authService.value.receive(
        "admin/seller/location",
        {},
        (s, d) => {
          if (s == 200) {
            location_stores.value = d.data;
            console.log(location_stores.value);
          }
        },
        (s, e) => {}
      );
    };
    const location_stores = ref({});
    return {
      authService,
      get_locations,
      location_stores,
    };
  },
  methods: {
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
    salam() {
      console.log("fuck this days");
      console.log(this.$refs.alizoka);
      this.$nextTick(() => {
        this.$refs.marker.mapObject.openPopup();
      });
    },
  },
  mounted() {
    this.salam();
  },
};
</script>
<style lang="scss" scoped>
.map-container {
  padding-top: 15px;
  .inner-wrapper {
    border-radius: 15px;
    height: 85vh;
    overflow: hidden;
  }
}
</style>
<style lang="scss">
.map {
  .leaflet-popup-content{
      font-family: IRANSans;
  }
}
</style>